var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-flow-chart"},[_c('div',{ref:"chartContainer",staticClass:"chart-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }